import gql from "graphql-tag"

export default gql`
  query($recruiterType: String, $industryId: String) {
    companySizes(
      settings: { recruiterType: $recruiterType, industryId: $industryId }
    ) {
      id
      translationKey
      enoughData
    }
  }
`
